<template>
  <el-select
    filterable
    remote
    v-model="relatedApprovalId"
    placeholder="WorkWeixinRelatedApproval 企业微信关联申请单"
    clearable>
  </el-select>
</template>

<script>
export default {
    name: 'WorkWeixinRelatedApproval',

    data() {
        return {
            relatedApprovalId: null
        };
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/WorkWeixinRelatedApproval.vue